// extracted by mini-css-extract-plugin
module.exports = {"header":"ApplicationProcess_header__bQ3YC","water":"ApplicationProcess_water__xghqe","rotate":"ApplicationProcess_rotate__OQ9OU","pulsate":"ApplicationProcess_pulsate__YmV_6"};